<template lang="pug">
	.creative--undo-history
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :width="720", :height="480", :autosize="true", :title="$tCaption('Undo history')", :closeOnOutsideClick="false", classes="tracker-dark")
			.creative--undo-history.popup.flex-col.space
				.history-item.flex-row.space(v-for="item in history", :class="{ 'undo-executed': item.undoExecuted }") 
					.grey {{$moment(item.date).format('hh:mm')}}
					span {{item.text}}
				Loader(v-if="isLoading", text="", :fullscreen="true")
			template(slot="actions-left")
				DxButton(:text="$tCaption('Undo')", @click="operations.undo()", :disabled="!operations.undoHistory().length || isUndoRedoExecuting")
				DxButton(:text="$tCaption('Redo')", @click="operations.redo()", :disabled="!operations.redoHistory().length || isUndoRedoExecuting")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="popupVisible = false")
</template>

<script>
	import _ from 'lodash';
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue'

	export default {
		translationCategory: 'creative.UndoHistory',
		name: 'creative--undo-history',
		components: { Popup, DxButton, Loader },
		props: ['operations', 'isUndoRedoExecuting'],
		data() {
			return {
				popupVisible: false,
				isLoading: 0
			}
		},
		computed: {
			history() {
				return _.orderBy(this.operations?.undoRedoHistory || [], ['date'], ['desc']);
			}
		},
		watch: {

		},
		mounted() {
			if (__DEBUG__)
				window.creativeUndoHistory = this;
		},
		destroyed() {
		},
		methods: {
			show() {
				this.popupVisible = false;
				this.$nextTick(() => this.popupVisible = true);
			}
		}
	}
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.creative--undo-history {
		.undo-executed {
			text-decoration: line-through;
		}
	}
</style>
